// This file is auto-generated by createFormatMapping.js
// Do not edit manually

import { FormatType } from './type';

// Not in the locale config, but we need to support them
export const INJECTED_FORMATS = {
  'dayOfTheWeek.long': 'dddd',
  'dayOfTheWeek.mid': 'ddd',
  year: 'YYYY',
  zone: '([GMT]Z)',
  'month.long': 'MMMM',
  'month.mid': 'MMM',
};

// Record<Array.from(set(displayType[])).sort().join(','), formatType>
export const formatMapping: Record<string, FormatType> = {
  time: 'lt',
  'date.long,year': 'LL',
  'date.long': 'LL-Y',
  'date.long,time,year': 'LLL',
  'date.long,time': 'LLL-Y',
  'date.long,dayOfTheWeek.long,time,year': 'LLLL',
  'date.long,dayOfTheWeek.long,time': 'LLLL-Y',
  'date.mid,year': 'll',
  'date.mid': 'll-Y',
  'date.mid,time,year': 'lll',
  'date.mid,time': 'lll-Y',
  'date.mid,dayOfTheWeek.mid,time,year': 'llll',
  'date.mid,dayOfTheWeek.mid,time': 'llll-Y',
  'date.mid,dayOfTheWeek.mid': 'll-Y+w',
  'time,zone': 'LT+to',
  'date.long,time,year,zone': 'LLL+to',
};
